import React, { useCallback, useRef, useState } from 'react';
import ScrollContainer from '../../../../components/ScrollContainer/ScrollContainer';
import styles from './UploadedVersionsList.module.scss';
import ClipCard from '../../../../components/ClipCard/ClipCard';
import { START_LIST_HEIGHT_FOR_MINI } from '../../../../constants/editorConst';

const UploadedVersionsList = ({ clipsListStyles, versionsList, activeVersion, showMenu, onSelect = () => { }, onOpenMenu }) => {

    const listRef = useRef(null);

    const [hoverCardId, setHoverCardId] = useState(null);
    const [showMinCard, setShowMinCard] = useState(false);

    const mouseLeaveScrollContainer = () => {
        setHoverCardId(null);
    };

    const handleHoverCard = useCallback(
        id => {
            setHoverCardId(id);
        },
        [hoverCardId]
    );

    const handleContainerHeightChanged = value => {
        setShowMinCard(value <= START_LIST_HEIGHT_FOR_MINI);
      };

    return <ScrollContainer
        className={styles.scrollContainer}
        mouseLeaveScrollContainer={mouseLeaveScrollContainer}
        innerStyles={clipsListStyles}
        innerRef={listRef}
        innerRefListenerCallback={handleContainerHeightChanged}
    >
        {versionsList.map((version, index) => <ClipCard
            key={version.id}
            author={version.author}
            handleSelectClip={onSelect}
            selectedClip={activeVersion?.id === version?.id}
            clip={version}
            clipIndex={index}
            handleDotsClick={onOpenMenu}
            showMenu={showMenu}
            cards={versionsList}
            lastCard={index === versionsList?.length - 1}
            isAutoScroll={true}
            handleHoverCard={handleHoverCard}
            showMinCard={showMinCard}
            thumbnailFallback={'movieFrame'}
        />)}
    </ScrollContainer>
};

export default UploadedVersionsList;